import React, { Component } from 'react'
import PropTypes from 'prop-types'
import HandoverNoteCard from './HandoverNoteCard'

export default class HandoverNotes extends Component {
  render() {
    return (
      <div style={styles.mainContainer}>
        {this.props.notes.map((note, i) => {
          return <HandoverNoteCard key={i} note={note} />
        })}
        {
          // if we want to edit notes (i.e. on current handover),
          // we can render this here if props.edit === true
        }
      </div>
    )
  }
}

const styles = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
}

HandoverNotes.propTypes = {
  notes: PropTypes.array.isRequired,
}
